function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#price_svg__clip0_1_74)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2 1.5a1 1 0 00-1 1v11a1 1 0 001 1h11.5a.5.5 0 00.5-.5v-2a.5.5 0 011 0v2a1.5 1.5 0 01-1.5 1.5H2a2 2 0 01-2-2v-11a2 2 0 012-2h10.5A1.5 1.5 0 0114 2v1.5a.5.5 0 01-1 0V2a.5.5 0 00-.5-.5H2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 9.5a3 3 0 013-3h2.5A1.5 1.5 0 0116 8v3a1.5 1.5 0 01-1.5 1.5H12a3 3 0 01-3-3zm3-2a2 2 0 100 4h2.5a.5.5 0 00.5-.5V8a.5.5 0 00-.5-.5H12z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 9.75a.25.25 0 100-.5.25.25 0 000 .5zm-.75-.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM2.43 2.467a.5.5 0 01.68.192.67.67 0 00.64.341h9.75A1.5 1.5 0 0115 4.5V7a.5.5 0 01-1 0V4.5a.5.5 0 00-.5-.5H3.76a1.67 1.67 0 01-1.522-.852.5.5 0 01.191-.68z"
}));
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "price_svg__clip0_1_74"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})));
function SvgPrice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}
export default SvgPrice;